import { render, staticRenderFns } from "./ExtraFieldQuickEditFieldSelect.vue?vue&type=template&id=5fa41064"
import script from "./ExtraFieldQuickEditFieldSelect.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldQuickEditFieldSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa41064')) {
      api.createRecord('5fa41064', component.options)
    } else {
      api.reload('5fa41064', component.options)
    }
    module.hot.accept("./ExtraFieldQuickEditFieldSelect.vue?vue&type=template&id=5fa41064", function () {
      api.rerender('5fa41064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/ExtraFieldQuickEditFieldSelect.vue"
export default component.exports